import PropTypes from 'prop-types';
import * as React from 'react';
import { TabHeaderInput } from './tab-header-input.component.js';
import { TabHeaderLabel } from './tab-header-label.component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function _object_without_properties(source, excluded) {
  if (source == null) return {};

  var target = _object_without_properties_loose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

({
  /**
  * The id of the matching tab
  */
  tabId: PropTypes.string.isRequired,

  /**
  * Props passed to the TabHeaderInput
  */
  inputProps: PropTypes.object,

  /**
  * Whether or not the header is disabled
  */
  disabled: PropTypes.bool
});

var TabHeader = function TabHeader(props) {
  var children = props.children,
      _props$inputProps = props.inputProps,
      inputProps = _props$inputProps === void 0 ? {} : _props$inputProps,
      tabId = props.tabId,
      disabled = props.disabled,
      labelProps = _object_without_properties(props, ["children", "inputProps", "tabId", "disabled"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeaderInput, _object_spread({
    tabId: tabId,
    disabled: !!disabled
  }, inputProps)), /*#__PURE__*/React.createElement(TabHeaderLabel, _object_spread({
    tabId: tabId
  }, labelProps), children));
};

export { TabHeader };